module.exports = __webpack_public_path__ + "static/podcast-o-aplikaci-springaudit-a44fe08f547e3f0fcd4db1955cad4b99.jpg";